<template>
    <div class="mx-10 ma-5">     
      <v-card class="pa-5">       
        <div>
          <PageTitleWithSearch 
          :title="'Inventories'"
          :btnName="'Add New Inventory'"
          :btnColor="'#00B3FF'" 
          :btnRoute="'/inventories/create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange">

        </PageTitleWithSearch>

        <v-progress-linear v-if="loading" indeterminate color="blue darken-2"></v-progress-linear>

          <v-data-table v-if="inventories" 
              :headers="headers"
              :items="inventories"
              :items-per-page="10"            
              :hide-default-footer="true"
              :disable-sort="true"
              :disable-pagination="true"
              id="data-table"
            >
            
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(item, index) in items" :key="index">
                <td class="text-left">{{ item.invoice_number }}</td>
                <td class="text-left">{{ item.date }}</td>
                <td class="text-left">{{ item.branch_code }}</td>
                <td class="text-left">{{ item.supplier_code }}</td>
                <td class="text-left">{{ item.comment }}</td>
                <td class="text-left">{{ item.payment_status }}</td>
                <td class="text-left">{{ item.payment_type }}</td>
                <td class="text-left">{{ item.status }}</td>
              </tr>
              </tbody>
            </template>

            </v-data-table>
        </div>

      <Pagination @previous="page--" @next="page++" :loading="loading" :total="total" :page="page" :totalPages="totalPages" class="mt-5"></Pagination>
      </v-card>      
    </div>
  </template>

  <script>
  import { createNamespacedHelpers } from "vuex";
  const { mapGetters } = createNamespacedHelpers("auth");
  
  import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
  import Pagination from "@/components/shared/Pagination";
  import { InventoryService } from "@/services/inventory-service.js";
  
  export default {
    name: "InventoryGrid",
    components: { PageTitleWithSearch, Pagination },
    data () {
      return {
        inventories: [],
        page: 1,
        search: "",
        loading: false,
        role: localStorage.getItem("role") || null,
        total : null,
        totalPages : null,

        headers: [
        { text: "Supplier Invoice No", value: "invoice_number", align: "left", },
        { text: "Invoice Data", value: "date", align: "left", },
        { text: "Branch Code", value: "branch_code", align: "left",},
        { text: "Supplier Code", value: "supplier_code", align: "left", },
        { text: "Comment", value: "comment", align: "left", },
        { text: "Payment Status", value: "payment_status", align: "left", },
        { text: "Payment Type", value: "payment_type", align: "left", },
        { text: "Status", value: "status", align: "left", },
      ],
        
      };
      
    },
    computed: {
      ...mapGetters({
        profile: "profile",
        hasPermission: "hasPermission",
      }),
    },
    created() {
      this.$store.dispatch("auth/getProfile");
      this.getInventoryList();
    },
  
    watch: {
      search() {
        this.page = 1;
        this.getInventoryList();
      },
      page() {
        this.getInventoryList();
      },
    },
  
    methods: {

      async getInventoryList() {
        this.loading = true;
        try{
          const response = await InventoryService.getInventoryList(this.search, this.page);
          this.inventories = response.data.data; 
          this.total = response.data.total;
          this.totalPages = response.data.last_page;
          console.log("Response : ",response.data);
        } catch(error) {
          console.error("Error fetching inventory list:", error);
        } finally {
          this.loading = false;
        }
      },

      searchChange(value) {
        this.search = value;
      },
 
    },
  };
  
  </script>